import uly from "ulysses/base";
import $ from "jquery";
import ko from "knockout";
import solr_parser from "lucene_query_parser";
import "ulysses/widgets";
import "ulysses/widgets/search/search";

var START=0,QUOTED=1,TEXT=2;
function quotify(tokens) {
    return $.map(tokens, function(v) {
        if (v && v.indexOf(" ") >= 0) {
            return "\"" + v + "\"";
        }
        return v;
    });
}
function split_text(text, prefix) {
    var state = START;
    var ctok = null;
    var toks = [];
    for (var k = 0;k<text.length;++k) {
        var letter = text[k];
        if (state == START) {
            if (letter != " " && letter != "\"") {
                ctok = (ctok || "") + letter;
                state = TEXT;
            }
            if (letter == "\"")
                state = QUOTED;
        }
        else if (state == TEXT) {
            if (letter == " " || letter == "\"") {
                if (ctok) {
                    toks.push(ctok);
                    ctok = null;
                }
                if (letter == "\"")
                    state = QUOTED;

            }
            else ctok = (ctok || "") + letter;
        }
        else if (state == QUOTED) {
            if (letter == "\"") {
                if (ctok) {
                    toks.push(ctok);
                    ctok = null;
                }
                state = START;
            }
            else ctok = (ctok || "") + letter;
        }
    }
    if (ctok) { toks.push(ctok); }
    prefix = prefix || "";
    var final_toks = $.map(toks, function(v) {
        if (v.indexOf(" ")>=0)
            return prefix + "\""+v+"\"";
        return prefix + v;
    });
    return  final_toks.join(" ");
}
ko.bindingHandlers.search_panel = {
    "init":function(elt, va, bindings, model, context) {





        var widget_model = ko.unwrap(va());

        var settings = ko.unwrap(widget_model.settings);
        var parameters = ko.unwrap(settings.parameters);
        var panel_model = {
            "text":ko.observable(""),
            "type":ko.observable(),
            "notext":ko.observable(""),
            "title":ko.observable(""),
            "label":ko.observableArray([]),
            "last_modified": { "within":ko.observable(), "of":ko.observable() },
            "principal_date": { "within":ko.observable(), "of":ko.observable() },
            "attachment":ko.observable(false),
            "custom":ko.observable()
        };
        var changing = true;
        var panel_subscription = ko.pureComputed(function() {
            return ko.toJS(panel_model);
        }).subscribe(function(new_value) {
            if (changing || $(elt).data("changing"))
                return;
            changing = true;
            var widget_model = ko.unwrap(va());
            var settings = ko.unwrap(widget_model.settings);
            var parameters = ko.unwrap(settings.parameters);

            var text = "";
            if (new_value.text && new_value.text != "")
                text += new_value.text;
            if (new_value.type && new_value.type != "") {
                text += " type:" + new_value.type;
            }
            if (new_value.notext && new_value.notext != "") {
                text += split_text(new_value.notext, " -");
            }
            if (new_value.title && new_value.title != "") {
                text += split_text(new_value.title, " title:");
            }
            if (new_value.label && new_value.label.length > 0) {
                text += " " + $.map(new_value.label, function(v,i) { return "label:"+v; }).join(" ");
            }
            if (parameters)
                parameters._search_body(text);
            changing = false;
        });
        changing = false;
        var child_context = context.createChildContext({
            "panel_model":panel_model,
            "date_refs":[
                {"caption":_("search_panel_caption_today", "Today"), "value":"today" },
                {"caption":_("search_panel_caption_yesterday", "Yesterday"), "value":"yesterday" },
                {"caption":_("search_panel_caption_tomorrow", "Tomorrow"), "value":"yesterday" },
                {"caption":_("search_panel_caption_a_week_ago", "A week ago"), "value":"yesterday" },
                {"caption":_("search_panel_caption_a_month_go", "A month go"), "value":"yesterday" },
                {"caption":_("search_panel_caption_a_year_ago", "A year ago"), "value":"yesterday" }
            ],
            "date_intervals":[
                {"caption":_("search_panel_caption_minutes", "Minutes"), "value":"minutes" },
                {"caption":_("search_panel_caption_hours", "Hours"), "value":"hours" },
                {"caption":_("search_panel_caption_days", "Days"), "value":"days" },
                {"caption":_("search_panel_caption_weeks", "Weeks"), "value":"weeks" },
                {"caption":_("search_panel_caption_months", "Months"), "value":"months" },
                {"caption":_("search_panel_caption_years", "Years"), "value":"years" }
            ],
            "types":ko.observable([
            ]),
            "facets":ko.observable([
            ])

        });
        $(elt).data("search_panel_model", panel_model);
        $(elt).data("search_panel_context", child_context);
        ko.applyBindingsToDescendants(child_context, elt);
        return { "controlsDescendantBindings":true };
    },
    "update":function(elt, va, allbindings, model, context) {
        if ($(elt).data("changing"))
            return;
        $(elt).data("changing", true);
        try {
            var widget_model = ko.unwrap(va());
            var settings = ko.unwrap(widget_model.settings);
            var parameters = ko.unwrap(settings.parameters);
            var panel_model = $(elt).data("search_panel_model");

            //need to parse the search string and fill in the panel model.

            var parsed = solr_parser.parse(ko.unwrap(parameters ? parameters._search_body : ""));
            panel_model.text("");
            panel_model.title("");
            panel_model.notext("");
            var child_context = $(elt).data("search_panel_context");
            //TODO: more...
            try {
                var results = ko.unwrap(widget_model.search_results);
                if (results) {
                    console.log( results);
                    var facets = results.facets;
                    if (facets && facets.facet_fields) {
                        var new_facets = [];
                        $.each(facets.facet_fields, function(idx, facet_data) {
                            var vals =  {};
                            $.each(facet_data.data, function(key,val) {
                                if (val) {
                                    vals[key] = val;
                                }
                            });
                            new_facets.push( { "caption":facet_data.caption, "name":facet_data.name, "data":vals });
                            if (facet_data.name == "_type") {
                                child_context.$data.types($.map(vals,
                                    function(val,key) {
                                        return { "id":key, caption:key + " [" + val +"]"};
                                    })
                                );
                            }
                        });

                    }
                    child_context.$data.facets(facets);
                }
            }
            catch(e) {
                console.error(e, e.get_stack());
            }
            var text = [], notext = [], title = [];
            var textualize = function(node) {
                var result = [];
                if (node.left) {
                    result.push(textualize(node.left));
                }
                if (node.operator) {
                    if (node.operator == "AND" || node.operator == "<implicit>")
                        result.push("");
                    else result.push(node.operator);
                }
                else
                {
                    var r = node.prefix || "";
                    if (node.field)
                        r += node.field + ":";
                    if (node.term)
                        r += node.term;
                    result.push(r);
                }
                if (node.right) {
                    result.push(textualize(node.right));
                }
                return result.join(" ");
            };
            var process_node = function (node) {
                if (node.operator && node.operator == "OR") {
                    text.push(textualize(node));
                } else if (node.operator) {
                    if (node.left)
                        process_node(node.left);
                    if (node.right)
                        process_node(node.right);
                } else {
                    if (node.left)
                        process_node(node.left);
                    else {
                        if (node.field == "title") {
                            title.push(node.term);
                        } else if (node.field == "text" || !node.field) {
                            if (node.prefix == "-")
                                notext.push(node.term);
                            else text.push(node.term);
                        }
                    }
                }
            };

            process_node(parsed);
            if (text.length)
                panel_model.text(quotify(text).join(" "));
            if (title.length)
                panel_model.title(quotify(title).join(" "));
            if (notext.length)
                panel_model.notext(quotify(notext).join(" "));

            //panel_model.text(ko.unwrap(parameters._search_body));


        } finally {
            $(elt).data("changing", false);
        }
    }
};
